<template>
  <div v-if="start">
    <div v-if="!currentChannel">
      <p>Такого канала не существует.</p>
    </div>
    <div v-else class="w-full">
      <vs-tabs position="left" alignment="left">
        <vs-tab label="Общее">
          <div class="pl-6 pt-2">
            <vx-card class="mb-6">
              <div class="vx-card__title mb-10">
                <h4 class="mb-4">Настройки канала «{{ currentChannel.name }}»</h4>
                <p>Замените название и описание канала, назначьте нужного бота и группу операторов.</p>
              </div>
              <div class="vx-row mb-12">
                <div class="vx-col w-full lg:w-1/2 mb-6">
                  <vs-input
                    class="w-full"
                    label="Название канала: *"
                    placeholder="Например, Техподдержка"
                    name="name"
                    v-model="currentSettings.name"
                    v-validate="'required'"
                    :class="isEditedClass(currentSettings.name, settings.name)"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
                <div class="vx-col w-full lg:w-1/2 mb-6">
                  <vs-input
                    class="w-full"
                    label="Описание канала:"
                    placeholder="Например, для сбора обратной связи"
                    name="description"
                    v-model="currentSettings.description"
                    :class="isEditedClass(currentSettings.description, settings.description)"
                  />
                  <span class="text-danger text-sm"
                        v-show="errors.has('description')">{{ errors.first('description') }}</span>
                </div>
                <div class="vx-col w-full lg:w-1/2 mb-6">
                  <div class="vs-input--label">Выбор бота:</div>
                  <v-select
                    label="text"
                    v-model="currentSettings.scenario_slug"
                    :clearable="false"
                    :reduce="option => option.value"
                    :options="allBotsOptions"
                    :class="isEditedClass(currentSettings.scenario_slug, settings.scenario_slug)"
                  />
                </div>
                <div class="vx-col w-full lg:w-1/2 mb-6">
                  <div class="vs-input--label">Выбор группы операторов:</div>
                  <v-select
                    label="text"
                    v-model="currentSettings.settings['auto_assignment.slug']"
                    :clearable="false"
                    :reduce="option => option.value"
                    :options="allGroupsOptions"
                    :class="isEditedClass(currentSettings.settings['auto_assignment.slug'], settings.settings['auto_assignment.slug'])"
                  />
                </div>
              </div>

              <div class="mb-6">

                <div class="vx-row">
                  <div class="vx-col w-full lg:w-1/2 mb-6">
                    <div class="mb-6">
                      <div class="mb-2 flex items-center">
                        <b class="mr-4">Автозавершение чата через:</b>
                        <v-select
                          style="width: 200px"
                          label="text"
                          v-model="currentSettings.settings['auto_close_period']"
                          :clearable="false"
                          :reduce="option => option.value"
                          :options="autoCloseOptions"
                          :class="isEditedClass(currentSettings.settings['auto_close_period'], settings.settings['auto_close_period'])"
                        />
                      </div>
                    </div>
                    <vs-checkbox
                      v-model="currentSettings.settings['allow_scenario_interruption_by_operator']"
                      class="mb-4 items-start"
                      :class="isEditedClass(currentSettings.settings['allow_scenario_interruption_by_operator'], settings.settings['allow_scenario_interruption_by_operator'])">
                      <div class="ml-2">
                        <div class="mb-2"><b>Позволить оператору перехватить переписку между клиентом и ботом?</b></div>
                        Оператор сможет написать сообщение, когда клиент общается с ботом. Бот выключится, а оператор закрепит обращение за собой
                      </div>
                    </vs-checkbox>
                    <vs-checkbox
                      v-model="currentSettings.settings['e2e.enabled']"
                      class="mb-4 items-start"
                      :class="isEditedClass(currentSettings.settings['allow_scenario_interruption_by_operator'], settings.settings['allow_scenario_interruption_by_operator'])">
                      <div class="ml-2">
                        <div class="mb-2"><b>Включить сквозную аналитику?</b></div>
                        Собирать все параметры запросов, с которыми пользователь посещает сайт (например, UTM метки)
                      </div>
                    </vs-checkbox>
                  </div>
                  <div class="vx-col w-full lg:w-1/2 mb-6">
                    <div class="vx-card__title mb-10">
                      <h4>Настройки почты:</h4>
                    </div>

                    <vs-checkbox
                      v-model="currentSettings.settings['email.notify.new_sessions']"
                      class="mb-4"
                      :class="isEditedClass(currentSettings.settings['email.notify.new_sessions'], settings.settings['email.notify.new_sessions'])">
                      Уведомлять о новых и повторных обращениях
                    </vs-checkbox>

                    <vs-checkbox
                      v-model="currentSettings.settings['email.notify.assignment']"
                      class="mb-4"
                      :class="isEditedClass(currentSettings.settings['email.notify.assignment'], settings.settings['email.notify.assignment'])">
                      Уведомлять оператора о переводе чата на него
                    </vs-checkbox>

                    <vs-checkbox
                      v-model="currentSettings.settings['email.notify.manual_dialog_switch']"
                      class="mb-6"
                      :class="isEditedClass(currentSettings.settings['email.notify.manual_dialog_switch'], settings.settings['email.notify.manual_dialog_switch'])">
                      Уведомлять о переключении диалога на оператора
                    </vs-checkbox>

                    <vs-checkbox
                      v-model="currentSettings.settings['email.notify.operator_unavailable']"
                      class="mb-6"
                      :class="isEditedClass(currentSettings.settings['email.notify.operator_unavailable'], settings.settings['email.notify.operator_unavailable'])">
                      Уведомлять о нераспознанных сообщениях клиента
                    </vs-checkbox>

                    <div class="mb-4">
                      <div class="vs-input--label">Получатели уведомлений на почту:</div>
                      <v-select
                        taggable
                        multiple
                        name="emails"
                        v-validate="'email'"
                        v-model="currentSettings.settings['email.receivers_list']"
                        :class="isEditedClass(currentSettings.settings['email.receivers_list'], settings.settings['email.receivers_list'])"
                      >
                        <span slot="no-options"></span>
                      </v-select>
                      <span class="text-danger text-sm" v-show="errors.has('emails')">{{ errors.first('emails') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>
            <vx-card class="mb-6">
              <div class="vx-card__title mb-10">
                <h4 class="mb-4">Настройка приветствий</h4>
                <p>Задайте приветствие, которое клиенты будут получать в зависимости от работы вашего центра.</p>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full lg:w-1/2 mb-10">
                  <TextareaWithLock
                    label="Новый клиент, компания работает"
                    v-model="currentSettings.settings['greeting.new_client.operator_online']"
                    :is-edited-class="isEditedClass(
                currentSettings.settings['greeting.new_client.operator_online'],
                settings.settings['greeting.new_client.operator_online']
              )"
                  />
                </div>
                <div class="vx-col w-full lg:w-1/2 mb-10">
                  <TextareaWithLock
                    label="Новый клиент, компания НЕ работает"
                    v-model="currentSettings.settings['greeting.new_client.operator_offline']"
                    :is-edited-class="isEditedClass(
                currentSettings.settings['greeting.new_client.operator_offline'],
                settings.settings['greeting.new_client.operator_offline']
              )"
                  />
                </div>
                <div class="vx-col w-full lg:w-1/2 mb-10">
                  <TextareaWithLock
                    label="Постоянный клиент, компания работает"
                    v-model="currentSettings.settings['greeting.existing_client.operator_online']"
                    :is-edited-class="isEditedClass(
                currentSettings.settings['greeting.existing_client.operator_online'],
                settings.settings['greeting.existing_client.operator_online']
              )"
                  />
                </div>
                <div class="vx-col w-full lg:w-1/2 mb-10">
                  <TextareaWithLock
                    label="Постоянный клиент, компания НЕ работает"
                    v-model="currentSettings.settings['greeting.existing_client.operator_offline']"
                    :is-edited-class="isEditedClass(
                currentSettings.settings['greeting.existing_client.operator_offline'],
                settings.settings['greeting.existing_client.operator_offline']
              )"
                  />
                </div>
              </div>
            </vx-card>
          </div>
        </vs-tab>
        <vs-tab label="Мессенджеры">
          <div class="pl-6 pt-2">
            <MessangersList
              class="mb-6"
              :channel-slug="currentChannel.slug"
            />
          </div>
        </vs-tab>
        <vs-tab label="Интеграции">
          <div class="pl-6 pt-2">
            <ServicesList
              :channel-slug="currentChannel.slug"
            />
          </div>
        </vs-tab>
        <vs-tab label="Webhooks">
          <div class="pl-6 pt-2">
            <Webhooks
              :channel-slug="currentChannel.slug"
            />
          </div>
        </vs-tab>
      </vs-tabs>


      <SaveBlock
        :show="hasChanges"
        :loading="loading"
        @accept="saveSettings"
        @cancel="cancelChanges"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { autoCloseOptions } from '../../data/options'
import { copyObject, compareObjects, isEditedClass, mergeDeep } from '../../helpers/helpers'

import Channels from '../../api/http/models/channels/Channels'
import Groups from '../../api/http/models/Groups'
import Scenarios from '../../api/http/models/Scenarios'
import ChannelsUpdateOneData from '../../api/http/models/channels/ChannelsUpdateOneCast'

import MessangersList from './components/MessangersList'
import ServicesList from './components/ServicesList'
import Webhooks from './components/Webhooks'
import TextareaWithLock from '../../components/TextareaWithLock'

export default {
  data () {
    return {
      start: false,
      loading: false,

      // Опции для селектов
      autoCloseOptions,
      allGroupsOptions: [{text: 'Не подключать операторов', value: null}],
      allBotsOptions: [{text: 'Не использовать бота', value: null}],

      // Полученные данные
      currentChannel: null,

      // Настройки для изменения
      currentSettings: {},
      hasChanges: false,

      // Настройки для эталона
      settings: mergeDeep({}, ChannelsUpdateOneData)
    }
  },

  computed: mapGetters(['authUserCompany']),

  components: {
    MessangersList,
    ServicesList,
    Webhooks,
    TextareaWithLock
  },

  watch: {
    currentSettings: {
      deep: true,
      handler (newVal) {
        this.hasChanges = !compareObjects(newVal, this.settings)
      }
    }
  },

  async created () {
    const response = await Channels.getOne(this.authUserCompany.slug, this.$route.params.channelSlug)
    if (response.data) {
      this.setData(response.data)
      // Подтягивание групп
      const groups = await Groups.getAll(this.authUserCompany.slug)
      if (groups.data) {
        this.allGroupsOptions.push(
          ...groups.data.map(group => ({
            text: group.name,
            value: group.slug
          }))
        )
      }
      // Подтягивание ботов
      const bots = await Scenarios.getAll(this.authUserCompany.slug)
      if (bots.data) {
        this.allBotsOptions.push(
          ...bots.data.map(bot => ({
            text: bot.name,
            value: bot.slug
          }))
        )
      }
    }
    await this.copySettings()
    this.start = true
  },
  methods: {
    isEditedClass,

    copySettings () {
      this.currentSettings = copyObject(this.settings)
    },

    cancelChanges () {
      this.copySettings()
    },

    setData (data) {
      this.currentChannel = data
      this.settings = mergeDeep(this.settings, this.currentChannel)
    },

    async saveSettings () {
      const validate = await this.$validator.validateAll()
      if (validate) {
        this.loading = true
        const response = await Channels.updateOne(this.authUserCompany.slug, this.currentChannel.slug, this.currentSettings)
        if (response.status === 'success' && response.data) {
          this.setData(response.data)
          this.copySettings()
          this.$vs.notify({
            color: 'success',
            title: 'Все настройки успешно обновлены',
            text: ''
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'При сохранении произошла ошибка',
            text: ''
          })
        }
        this.loading = false
      }
    }
  }
}
</script>
